import React, { memo } from 'react';
import ObtRamasArbol from "./ObtRamasArbol";
import "./Nodos.css"

export default memo(({ id, data, isConnectable }) => {
  return (
    <div className='inicialRaiz'>
      <div className='customRaiz' style={{ display: 'flex', flexDirection: 'colum',flexShrink: 0, justifyContent:'space-evenly'}}>
        <div>
          <div className='cajadatosraiz' style={{writingMode: 'vertical-lr',transform: 'rotate(180deg)'}}>{data.label}{data.label2!==''?<br></br>:''}{data.label2}</div>
        </div>
        {ObtRamasArbol(id,data.ramas,{isConnectable})}
      </div>
    </div>
  );
});